import { Group, Text, UnstyledButton } from '@mantine/core';
import { FONT_WEIGHTS } from 'src/UI/theme/theme';

type AddNewBarProps = {
  onAddIncome: () => void;
  onAddExpenditure: () => void;
  onAddLifeEvent: () => void;
};

export default function AddNewBar({
  onAddIncome,
  onAddExpenditure,
  onAddLifeEvent,
}: AddNewBarProps) {
  return (
    <Group bg="gray.0" px="lg" py="xs" gap="xs" align="center" style={{ borderRadius: 20 }}>
      <Text fw={FONT_WEIGHTS.medium} size="sm" c="gray.4">
        Add new:
      </Text>
      <Group gap="lg">
        <AddNewLink testId="add-new-income" label="Income" onClick={onAddIncome} />
        <AddNewLink testId="add-new-expenditure" label="Expenditure" onClick={onAddExpenditure} />
        <AddNewLink testId="add-new-life-event" label="Life event" onClick={onAddLifeEvent} />
      </Group>
    </Group>
  );
}

type AddNewLinkProps = {
  testId: string;
  label: string;
  onClick: () => void;
};

function AddNewLink({ testId, label, onClick }: AddNewLinkProps) {
  return (
    <UnstyledButton onClick={onClick} data-testid={testId} aria-label={`Add new ${label}`}>
      <Text fw={FONT_WEIGHTS.semibold} size="sm" c="brand.6">
        {label}
      </Text>
    </UnstyledButton>
  );
}
